import { ADMIN_URL } from "@/utils/constant"
import request from "@/utils/request"
export function getLogList(currentPage,pageSize,params){
  return request({
    url:`${ADMIN_URL}/getloglist`,
    method:'get',
    params: {
      page:currentPage,
      limit:pageSize,
      ...params
    }
  })
}
